import ApiService from '@/common/api/api.service';

let apiBasePath = 'TurmaCurriculo';

const TurmaCurriculo = {
  // FUNÇÕES CRUD:
  async criar(form) {
    let { data } = await ApiService.post(`${apiBasePath}`, form);
    return data;
  },
  async editar(form) {
    let { data } = await ApiService.put(`${apiBasePath}`, form);
    return data;
  },
  async excluir(turmaId) {
    let { data } = await ApiService.delete(`${apiBasePath}/${turmaId}`);
    return data;
  },
  // FUNÇÕES DE OBTENÇÃO DE DADOS:
  async listarTodos(paginacao, campoOrdenado, ordem) {
    let { data } = await ApiService.get(`${apiBasePath}/listar-todos`, {
      params: {
        TamanhoDaPagina: paginacao.tamanhoDaPagina,
        NumeroDaPagina: paginacao.numeroDaPagina,
        CampoOrdenado: campoOrdenado,
        OrdenacaoAscendente: ordem,
      },
    });
    return data;
  },
  async listarTodosPaginado(paginacao, campoOrdenado, ordem) {
    let { data } = await ApiService.get(
      `${apiBasePath}/obter-turmas-paginado`,
      {
        params: {
          TamanhoDaPagina: paginacao.tamanhoDaPagina,
          NumeroDaPagina: paginacao.numeroDaPagina,
          CampoOrdenado: campoOrdenado,
          OrdenacaoAscendente: ordem,
        },
      }
    );

    data.data.itens = data.data.itens.map((i) => ({
      descricao: i.descricao,
      fase: i.faseDescricao,
      id: i.id,
    }));
    
    return data;
  },
  async obterPorId(id) {
    let { data } = await ApiService.get(`${apiBasePath}/${id}`);
    return data;
  },
};

export default TurmaCurriculo;
